
// import { useAuthState } from 'react-firebase-hooks/auth';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import toast from 'react-hot-toast';
import { useState } from 'react';
import { Flash, Eye, EyeSlash } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';


export const Login = () => {
  
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  // const [user, loading, error] = useAuthState(auth)
  const [APIloading, setAPILoading] = useState(false)
  const [passwordType, setPasswordType] = useState('password')  

  const navigate = useNavigate()
  
  const signIn = () => {
    setAPILoading(true)
    if(email === '' || password === '') {
      toast.error('Please fill all the fields')
      setAPILoading(false)
      return
    }
    signInWithEmailAndPassword(auth, email, password).then(resp => {
      navigate("/")
    }).catch(err => {
      toast.error(err.message.split(':')[1])
      setAPILoading(false)
    })
  } 
  
  return (
    <div style={{overflow: "hidden"}} className='h-screen w-screen flex flex-col items-center p-5 justify-center'>
      <p className='text-sm font-nunito mb-4 mt-auto'>Welcome !!</p>
      <p className='text-3xl font-nunito flex flex-row gap-[10px] items-center font-medium mb-[50px]'>
        <Flash
          size="42"
          color="#0080f3"
          variant="Bulk"
        />
        Medisupport
      </p>
      
      <input type="email" placeholder='Email' 
        value={email} onChange={(e) => setEmail(e.target.value)} 
        className='px-5 h-[46px] rounded-sm font-nunito bg-white mb-3 w-[85%]' 
      />
      <div className='flex w-full mb-3 flex-row justify-center items-center'>
        <input type={passwordType} placeholder='Password' 
          value={password} onChange={(e) => setPassword(e.target.value)} 
          className='px-5 ml-[-20px] h-[46px] rounded-sm font-nunito bg-white w-[85%]' 
        />
        {passwordType === "password" && <Eye onClick={() => setPasswordType("text")} size="22" color="#333" className='ml-[-40px]' variant="TwoTone"/>}
        {passwordType === "text" && <EyeSlash onClick={() => setPasswordType("password")} size="22" color="#333" className='ml-[-40px]' variant="TwoTone"/>}
      </div>
      <button onClick={signIn} disabled={APIloading} className={'px-5 h-[46px] rounded-sm bg-blue-500 text-white font-nunito w-[85%] text-center' + (APIloading ? "bg-blue-200 opacity-[0.5] cursor-not-allowed" : "bg-blue-500")}>
        {APIloading ? (
          <div className='flex items-center justify-center'>
            <div className='animate-spin rounded-full h-6 w-6 border-t-2 border-white mr-8'></div>
            Logging In ...
          </div>
        ) : (
          'Login'
        )}
      </button>

      <p onClick={() => navigate('/forgotPassword')} className='text-center mt-auto'>Forgot Password</p>
      <p onClick={() => navigate('/signup')} className='text-center mt-[20px] mb-[50px]'>Not a user ?  Signup Here</p>
    </div>
  )
}